// @file Menu row styles and roles, in a module of their own so a store or composable can build
// menu rows without importing the component (and its button subtree) into that caller's chunk.

export enum OzMenuRowsRowStyle {
  Default = 'Default',
  Primary = 'Primary',
  Secondary = 'Secondary',
  Danger = 'Danger',
  Disabled = 'Disabled',
  Highlighted = 'Highlighted',
  Focused = 'Focused',
}

export enum OzMenuRowsRowRole {
  MenuItem = 'menuitem',
  MenuItemRadio = 'menuitemradio',
  MenuItemCheckbox = 'menuitemcheckbox',
}
